import { IAnswerModel } from '../../state/stores/Question/AnswerModel';
import { SnapshotOrInstance } from 'mobx-state-tree';


interface HasMeta {
  meta?: readonly {
    key: string,
    value: string,
  }[] | null
}
export const getAnswerByKey = (key: string, answers?: SnapshotOrInstance<IAnswerModel>[]) =>
  answers?.find(a => a.key === key);
export const getMetaValue = (key: string, a?: HasMeta) =>
  a?.meta?.find(m => m.key === key)?.value;
export const unwrapMeta = <T extends string>(keys: T[], a?: HasMeta): Record<T, string | undefined> => {
  return keys.reduce((meta, key) => {
    const value = getMetaValue(key, a);
    meta[key] = value;
    return meta;
  },{} as Record<T, string | undefined>);
};
